import React, { useEffect } from 'react';
import { FieldProps } from '@rjsf/core';
import { DayTimeRange, DayTimeRangeType, MuiMaterial, Theme } from '../../';

const { FormControl, useMediaQuery } = MuiMaterial;

const DayTimeRangeField = ({
  formData,
  idSchema,
  schema,
  onChange,
  disabled,
  readonly,
  formContext: { t, onHasChanged },
}: FieldProps): JSX.Element => {
  const isSmallDevice = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const id = idSchema?.$id;
  const title = schema?.title;

  const [data, setData] = React.useState<Array<DayTimeRangeType>>(formData || []);

  const _onAdd = (value: Array<DayTimeRangeType>) => {
    const postValue = value.filter((v) => v.fromTime || v.toTime);
    onChange(postValue);
    setData(postValue);
    setTimeout(() => onHasChanged({ id }), 0);
  };

  useEffect(() => {
    setData(formData);
  }, [formData]);

  return (
    <FormControl fullWidth={true} key={`${id}-form-control`}>
      <DayTimeRange
        value={data}
        title={title}
        t={t}
        isSmallDevice={isSmallDevice}
        onAdd={_onAdd}
        disabled={disabled || readonly}
      />
    </FormControl>
  );
};

export default DayTimeRangeField;
